import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { APIService } from '@fry/lib/api';
import { ApiStore } from '@fry/lib/store';

import { Walkthrough, WalkthroughJSON } from './walkthrough';
import { WalkthroughState } from './walkthrough-state';

export interface ForUserOptions {
    show_all: boolean;
    regenerate: boolean;
    unresolved: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class WalkthroughsStore extends ApiStore<Walkthrough, WalkthroughJSON> {
    AssociatedModel = Walkthrough;

    docType = 'walkthrough';
    endpoint = 'walkthroughs';

    constructor(api: APIService) {
        super(api);
    }

    public getForUser(username: string,
                      options: ForUserOptions): Observable<Walkthrough[]> {
        return this.api.get(`${this.endpoint}/${username}/resolved`, options).pipe(
            map(pairs => {
                return pairs.map(pair => {
                    const walkthrough = new Walkthrough(pair.walkthrough);
                    const state = WalkthroughState.stateFromJSON(pair.state);
                    walkthrough.applyState(state);
                    return walkthrough;
                });
            })
        );
    }

    public hideWalkthroughForUser(walkthrough: Walkthrough, username: string, hide: boolean): Observable<any> {
        return this.api.patch(`${this.endpoint}/${username}/${walkthrough.state.doc._id}`,
                              { hidden: hide });
    }

    public hideWalkthroughStateForUser(state: string, username: string, hide: boolean): Observable<any> {
        return this.api.patch(`${this.endpoint}/${username}/${state}`,
                              { hidden: hide });
    }

    public getListForUser(username: string) {
        const options = {unresolved: true};
        return this.api.get(`${this.endpoint}/${username}`, options);
    }
}
